module.exports = __webpack_public_path__ + "officialStatic/img/parentBg.89d0ebc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/parentBg.jpg
// module id = wUAM
// module chunks = 0